import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContentService } from '../../../store/services/content.service';

@Component({
  selector: 'app-test-content',
  templateUrl: './test-content.component.html',
  styleUrls: ['./test-content.component.scss'],
})
export class TestContentComponent implements OnInit {
  @Input() contentId: number;
  currentEmail: string;

  inputForm: FormGroup;

  componentReady = false;

  constructor(private readonly contentService: ContentService) {
  }

  ngOnInit(): void {
    this.contentService.getContentInfo(this.contentId).subscribe(content => {
      this.inputForm.addControl(
        'email',
        new FormControl(this.currentEmail, [
          Validators.required,
          Validators.email,
        ]),
      );
      this.inputForm.addControl('content', new FormControl(content));
      this.componentReady = true;
    });
  }
}
